import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';
import {AnimalModel} from '../../models/animal.model';
import {AnimalMediaCategory} from '../../models/animal-media-category.enum';
import {AnimalMediaCategoryModel} from '../../models/animal-media-category.model';
import {SharedModule} from '../../../../shared/shared.module';
import {ChipModule} from 'primeng/chip';
import {Fieldset} from "primeng/fieldset";

export interface GalleryFilterState {
  showImages: boolean;
  showVideos: boolean;
  syncWithWebsite: boolean;
  sharePointImport: boolean;
  selectedCategories: AnimalMediaCategory[];
}

@Component({
  selector: 'app-gallery-header',
  templateUrl: './gallery-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoModule, SharedModule, ChipModule, Fieldset]
})
export class GalleryHeaderComponent {
  @Input() animal: AnimalModel | null = null;
  @Input() filter!: GalleryFilterState;
  @Input() mediaCategoryOptions: AnimalMediaCategoryModel[] = [];
  @Input() media: any[] = [];

  @Output() multiSelectToggle = new EventEmitter<void>();
  @Output() filterChange = new EventEmitter<void>();

  @Input() isMultiSelectMode: boolean = false;

  toggleCategoryFromString(value: string): void {
    this.toggleCategory(value as AnimalMediaCategory);
  }

  toggleCategory(value: AnimalMediaCategory): void {
    const selected = new Set(this.filter.selectedCategories);
    selected.has(value) ? selected.delete(value) : selected.add(value);
    this.filter.selectedCategories = Array.from(selected);
    this.filterChange.emit();
  }

  isSelectedCategory(value: string): boolean {
    return this.filter.selectedCategories.includes(value as AnimalMediaCategory);
  }

  onToggleMultiSelectMode(): void {
    this.isMultiSelectMode = !this.isMultiSelectMode;
    this.multiSelectToggle.emit();
  }
}
